<template>
    <div class="" v-if="currentStepBody">
        <div data-wizard-type="step-info" data-wizard-state="current">
            <h3 class="font-weight-bold mb-5 h5">
                {{ currentStepBody.tooltip_title }}
            </h3>
            <div
                class="font-size-lg text-dark-50"
                v-html="currentStepBody.tooltip_content"
            ></div>
            <div class="text-center">
                <img
                    :src="currentStepBody.tooltip_image_url"
                    alt="image"
                    class="mt-4 mb-4"
                    v-if="currentStepBody.tooltip_image_url"
                />
            </div>
            <div
                class="dm-tooltip-video"
                v-html="currentStepBody.tooltip_video"
                v-if="currentStepBody.tooltip_video"
            ></div>
        </div>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    computed: {
        ...mapState(useSubmissionWizardStore, ["currentStepBody"]),
    },
};
</script>
